/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Container from "../../../Container/Container";
import _upperCase from "lodash/upperCase";
import partnerLogoSectionStyle from "./partnerLogoSectionStyle";
import Typography from "@mui/material/Typography";
import { useQuery } from "@tanstack/react-query";
import { fetchCollection, queryKeys } from "../../../../services/reactQuery/reactQueryService";
import _head from "lodash/head";
import { Box } from "@mui/material";
import { Partner } from "../../../../types/Partner";
import { AbstractCase } from "../../../../types/Entities/AbstractCase";

type PartnerLogoSectionProps = {
  containerStyle?: "divorceContainer" | "settlementContainer" | "smallPaddingContainer";
  partnerName: NonNullable<AbstractCase["acquisitionPartner"]>;
};

const PartnerLogoSection = ({ containerStyle = "divorceContainer", partnerName }: PartnerLogoSectionProps) => {
  const urlParams = {
    name: partnerName,
  };
  const { data: partnerEntities, isLoading } = useQuery<Partner[]>(queryKeys.collection("/partners", urlParams), () => fetchCollection("/partners", urlParams));

  const partnerEntity = _head(partnerEntities);

  if (isLoading || !partnerEntity?.encodedLogo) {
    return null;
  }

  return (
    <Container sx={partnerLogoSectionStyle[containerStyle]}>
      <Box sx={partnerLogoSectionStyle.logoGridContainer}>
        <Box sx={partnerLogoSectionStyle.logoGridItem}>
          <Typography variant={"h3"} sx={partnerLogoSectionStyle.logoText}>
            In Kooperation mit
          </Typography>
        </Box>
        <Box sx={partnerLogoSectionStyle.logoGridItem}>
          <Box component={"img"} sx={partnerLogoSectionStyle.logo} src={partnerEntity.encodedLogo} alt={_upperCase(partnerName) + " Kooperation Logo"} />
        </Box>
      </Box>
    </Container>
  );
};

export default PartnerLogoSection;
